export enum FragmentState {
  DELETED,
  CREATED,
  UNMODIFIED,
  MOVED,
}
